export const validationMixin = {
    data() {
        return {
            emailRegex: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            violations: [],
            RESPONSE_VALIDATION : 'RESPONSE_VALIDATION',
            RESPONSE_ERROR : 'RESPONSE_ERROR'
        }
    },
    methods: {
        validateEmail: function (email) {
            console.log("Server Validation Called..." + email);
            return this.emailRegex.test(String(email).toLowerCase());
        },
        serverValidation: function(fieldName,label) {
            //console.log("Server Validation Called..." + fieldName + ' ' + label)
            return [
                v => {
                    const extMessage = this.getViolation(fieldName);

                    if (extMessage) {
                        return label + ' ' + extMessage;
                    } else {
                        return true;
                    }
                }
            ]
        },
        requiredValidation: function(label) {
            //console.log("Required Called..." + label);
            return [v=>{if (v) {return true;} return label + ' is Required'}]
        },
        requiredEmailValidation: function(fieldName) {
            //console.log("Required Email Called..." + fieldName);
            return [
                v => {
                    const extMessage = this.getViolation(fieldName);

                    if (extMessage) {
                        return extMessage;
                    }
                    if (v && this.validateEmail(v)) {
                        return true;
                    } else {
                        return 'Must Enter Valid Email Address';
                    }
                }
            ]
        },
        getViolation : function(fieldName) {
            if (this.violations && this.violations.length > 0) {
                for (var i=0;i<this.violations.length;i++) {
                    if (this.violations[i].fieldName === fieldName) return this.violations[i].message;
                }
            }
            return null;
        },
        processErrors : function(error) {
            if (error) {
                if (error.violations) {
                    this.violations = error.violations;
                    this.showGenericErrors();
                    return this.RESPONSE_VALIDATION;
                } else if (error.is_error && error.message) {
                    this.$root.$emit('globalError',error.message);
                    return this.RESPONSE_ERROR;
                } else {
                    this.$root.$emit('globalError','An Unknown Error has Occurred');
                    return this.RESPONSE_ERROR;
                }
            }
        },
        showGenericErrors() {
            var msgs = [];
            if (this.violations) {
                this.violations.forEach((v) => {
                    if (!v.fieldName) {
                        msgs.push(v.message);
                    }
                })
            }
            if (msgs.length > 0) {
                this.$root.$emit('globalError', msgs.join('\r\n'));
            }

        }
    }
}
